import expand from './expand'

function createAccordion(el)  {

	const buttons = [...el.querySelectorAll('.accordion__button')]
	const objects = buttons.map(button => expand(button, onExpand))

	function onExpand (open, button, content) {
		const openClass = 'is-open'
		open ? button.parentNode.classList.add(openClass) : button.parentNode.classList.remove(openClass)

		if (open) {
			const toClose = objects.filter(object => object.button !== button)
			toClose.map(object => object.close())
		}
	}
}

export default function init() {
	[...document.querySelectorAll('.js-accordion')].map(createAccordion)
}
